import React, { Component } from "react";
import Hero from "./Hero.js";
import axios from "axios";
import _ from "lodash";
import problem from "../assets/problem.svg";
import solution from "../assets/solution.svg";
import { Link } from "react-router-dom";
import LogoBar from "./LogoBar";
import Related from "./Related";
import edge from "../assets/edge.svg";

class Services extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      services: [],
      currentService: 0
    };

    this.myDiv = React.createRef();
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/pages?slug=services").then(res => {
      this.setState(
        {
          data: res.data[0].acf,
          services: res.data[0].acf.services
          //   pageTitle: res.data[0].title.rendered,
          //   seo: res.data[0].yoast_meta,
          //   pageContent: res.data[0].content.rendered,
          //   sectionTitle: res.data[0].acf.team_section_headline,
          //   featuredImage: res.data[0].better_featured_image.source_url
        },
        () => window.scrollTo(0, 0)
      );
    });
  }

  renderServiceTab() {
    const { services, currentService } = this.state;
    return _.map(services, (service, i) => {
      if (i === currentService) {
        return (
          <div className="s-item active">
            <img src={service.icon} alt={service.name} />
            <h4>{service.name}</h4>
          </div>
        );
      } else {
        return (
          <div
            className="s-item"
            onClick={() =>
              this.setState({ currentService: i }, () => this.scrollIntoView())
            }>
            <img src={service.icon} alt={service.name} />
            <h4>{service.name}</h4>
            <a className="unl-button">
              Learn More <span>+</span>
            </a>
          </div>
        );
      }
    });
  }

  scrollIntoView() {
    if (window.innerWidth <= 760) {
      document.querySelector("#info").scrollIntoView();
    }
  }

  renderInfoBox() {
    const { services, currentService } = this.state,
      service = services[currentService];

    if (service) {
      return (
        <div className="infobox">
          <h2>{service.name}</h2>
          <div className="p1">
            <div className="p2">
              <img src={problem} alt="Problem" />
              <div className="dotted-line" />
            </div>
            <div className="problem" ref={this.myDiv}>
              <h4>Problem</h4>
              {service.problem}
            </div>
          </div>
          <div className="s1">
            <div className="s2">
              <img src={solution} alt="Solution" />
            </div>
            <div className="solution">
              <h4>Solution</h4>
              {service.solution}
              <Link to="/contact" className="btn main">
                Get Started
              </Link>
            </div>
          </div>
        </div>
      );
    }
  }

  render() {
    const { data } = this.state;

    return (
      <div>
        <Hero
          content={data.content_hero}
          linkTitle={data.link_title_hero}
          linkUrl={data.link_url_hero}
          image={data.background_image_hero}
          data={data}
        />
        <div className="edge-box">
          <img className="edge" src={edge} alt="Edge Element" />

          <div className="services-infobox">
            <div className="left">{this.renderServiceTab()}</div>
            <div className="right" id="info">
              {this.renderInfoBox()}
            </div>
          </div>
        </div>

        <LogoBar page="Services" />

        <Related />
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.js